// extracted by mini-css-extract-plugin
export var dividerLine = "_42-0";
export var errorBackground = "_42-1";